import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import {
  ARServicesDeliveryList,
  ARServicesPickupList,
} from '@/utils/PortalConstants';
import { ARServiceItem } from '@/models/airRoad';

export type PackageType = 'carton' | 'pallet';

export const bookingSteps = [
  'LEG_CHOOSE',
  'PACKAGE',
  'SPECIAL_OPTIONS',
  'CONFIRM',
] as const;

export type BookingStep = (typeof bookingSteps)[number];

export const bookingStepValues: ReadonlyDeep<Record<BookingStep, BookingStep>> =
  {
    LEG_CHOOSE: 'LEG_CHOOSE',
    PACKAGE: 'PACKAGE',
    SPECIAL_OPTIONS: 'SPECIAL_OPTIONS',
    CONFIRM: 'CONFIRM',
  };

export const bookingStepTitles: ReadonlyDeep<Record<BookingStep, string>> = {
  LEG_CHOOSE: 'Check delivery address',
  PACKAGE: 'Pack the items',
  SPECIAL_OPTIONS: 'Special options',
  CONFIRM: 'Complete booking',
};

export const stepperItems: ReadonlyDeep<
  {
    title: string;
    value: BookingStep;
  }[]
> = bookingSteps.map(function (bookingStep) {
  return {
    title: bookingStepTitles[bookingStep],
    value: bookingStepValues[bookingStep],
  };
});

export const stepSettings: ReadonlyDeep<
  Record<
    BookingStep,
    {
      prevText: string;
      nextText: string;
      prevIcon: string;
      nextIcon: string;
    }
  >
> = {
  LEG_CHOOSE: {
    prevText: 'Back',
    nextText: 'Next',
    prevIcon: 'mdi-arrow-left',
    nextIcon: 'mdi-arrow-right',
  },
  PACKAGE: {
    prevText: 'Back',
    nextText: 'Next',
    prevIcon: 'mdi-arrow-left',
    nextIcon: 'mdi-arrow-right',
  },
  SPECIAL_OPTIONS: {
    prevText: 'Back',
    nextText: 'Next',
    prevIcon: 'mdi-arrow-left',
    nextIcon: 'mdi-arrow-right',
  },
  CONFIRM: {
    prevText: 'Back',
    nextText: 'Book in AirRoad',
    prevIcon: 'mdi-arrow-left',
    nextIcon: 'mdi-send',
  },
};

export const defaultBookingState: ReadonlyDeep<{
  params: openapi.AirroadSingleCreateQueryOpenapi;
  data: openapi.AirroadSingleCreateBodyOpenapi;
  _extraProducts: openapi.AirroadJobDetailedContentOpenapi['stops'][0]['pickup_products'];
  _deliverySpecialOptions: Record<string, ARServiceItem>;
  _pickupSpecialOptions: Record<string, ARServiceItem>;
}> = {
  params: {
    with_alloc: true,
  },
  data: {
    job_date: '',
    job_id: NaN,
    ar_booked_leg: 1,
    items: [],
    ar_stops: [],
    special_options: [],
  },
  _extraProducts: [],
  _deliverySpecialOptions: ARServicesDeliveryList,
  _pickupSpecialOptions: ARServicesPickupList,
};

export const defaultBookingStepValidationState: ReadonlyDeep<
  Record<BookingStep, boolean | null>
> = {
  LEG_CHOOSE: true,
  PACKAGE: false,
  SPECIAL_OPTIONS: true,
  CONFIRM: true,
};
